<div class="p-2">
    <div class="p-4">
        <h2 class="mb-2">Select a Property</h2>
        <app-property-select-dialog-table 
            [rowClicked]="onPropertySelected"
            [organizationId]="organizationId"
            (selectedProperty)="onPropertySelected($event)"
        >
        </app-property-select-dialog-table>

        <div class="d-flex justify-content-end mt-4">
            <button mat-raised-button mat-dialog-close class="finish-button mx-2">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
        </div>
    </div>
</div>